import script from "./Nice.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nice.vue?vue&type=script&lang=ts&setup=true"

import "./Nice.vue?vue&type=style&index=0&id=63315908&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63315908"]])

export default __exports__